

































import {
  DynamicDocumentItem,
  DynamicDocumentItemData,
  InstallationModule,
  InstallationModuleData,
  MechanicInstallation,
  StatusFlags
} from "@/types";
import { PropType } from "vue";
import { InstallationModuleStatus } from "@/store/modules/installation";
import { isItemRequired } from "@/utilities";
import documentCtxMixin from "../document-ctx";

export default documentCtxMixin.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    installation: { type: Object as PropType<MechanicInstallation> },
    moduleData: Object as PropType<InstallationModuleData>,
    data: Object as PropType<DynamicDocumentItemData>,
    documentData: Array as PropType<DynamicDocumentItemData[]>,
    module: { type: Object as PropType<InstallationModule> }
  },

  // prefill data from moduleData default only on first render
  created() {
    if (
      this.meta.multiple &&
      this.data.value instanceof Array &&
      !this.data.value.length &&
      this.moduleData?.[this.item.field]
    ) {
      this.$set(this, "value", this.moduleData[this.item.field] as string[]);
    } else if (this.moduleData?.[this.item.field]) {
      this.$set(this, "value", this.moduleData[this.item.field] as string);
    }
  },

  computed: {
    isRequired(): boolean {
      return isItemRequired(this.item, this.documentData ?? [this.data]);
    },

    flags(): StatusFlags {
      return this.module.flags || {};
    },
    meta(): Record<string, any> {
      return this.item.meta ?? {};
    },
    isProcessing(): boolean {
      return this.status.status === "processing";
    },
    status(): InstallationModuleStatus {
      return this.$store.getters["installation/status"](this.installation.id, this.module.type);
    },
    isDisabled(): boolean {
      if (this.ctx.readonly) {
        return true;
      }

      switch (this.meta.disabled) {
        case "hasAssociation":
          return !!this.flags.hasAssociation || this.isProcessing;
        default:
          return false;
      }
    },

    value: {
      get(): string | string[] {
        if (this.meta.multiple) {
          if (this.data.value instanceof Array && this.data.value.length) {
            return this.data.value as string[];
          }

          return [];
        }

        const raw = (typeof this.data.value === "string" && !!this.data.value)
          ? this.data.value
          : this.moduleData?.[this.item.field];

        // Tolerate legacy array-shaped values (fields that used to be multi-select):
        // a single-select can only show one value, so take the first.
        if (Array.isArray(raw)) {
          return (raw[0] as string) ?? "";
        }

        return typeof raw === "string" && !!raw ? raw : "";
      },

      set(val: string | string[]) {
        this.data.value = val;
        this.$set(this.moduleData, this.item.field, val);
        this.$emit("save:document");
      }
    }
  },

  methods: {
    // Options may be plain strings (label === value) or { text, value } objects
    // (label !== value, e.g. "Productiemeter" shown for the stored value "Wocozon").
    // v-select hands the matched item to the selection slot; resolve its label.
    selectionLabel(item: string | { text: string; value: string } | undefined): string {
      if (item && typeof item === "object") {
        return item.text;
      }

      return item ?? "";
    }
  }
});
